import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiClientConstant, Table } from '@cureskin/api-client';
import { ConnectionService } from '../../../../services/connection-service';
import { Broadcaster } from '../../../../components/broadcaster';
import { InputType } from '../../../../../typings/client/input';
import { AppErrorType, AppErrorTypeMessage } from '../../../app-error.constants';

@Component({
  selector: 'audio-template-edit',
  templateUrl: './edit.html',
  styleUrls: ['./edit.scss'],
  standalone: false
})
export class AudioTemplateEditComponent {
  protected readonly apiClientConstant: typeof ApiClientConstant = ApiClientConstant;
  audioTemplateObject: Table.AudioTemplate;
  audioTemplateId: string;
  audioTemplateTypeOption: Array<InputType.SelectOption> = [];

  constructor(
    private connectionService: ConnectionService,
    private route: ActivatedRoute,
    private router: Router,
    private broadcaster: Broadcaster) {
  }

  async ngOnInit(): Promise<void> {
    this.audioTemplateObject = await this.getAudioTemplateObj();
    this.audioTemplateTypeOption = this.loadAudioTemplateOptions();
  }

  async saveAudioTemplate(): Promise<void> {
    try {
      await this.audioTemplateObject.save();
      this.broadcaster.broadcast('NOTIFY', { message: AppErrorTypeMessage.SAVED_SUCCESSFULLY, type: AppErrorType.SUCCESS });
      this.router.navigate(['products/audioTemplate']);
    } catch (error) {
      this.broadcaster.broadcast('NOTIFY', { message: error.message, type: AppErrorType.ERROR });
    }
  }

  private async getAudioTemplateObj(): Promise<Table.AudioTemplate> {
    this.audioTemplateId = this.route.snapshot.params.id;
    if (this.audioTemplateId) {
      return await this.connectionService
        .findOneAudioTemplates( { where: { objectId: this.audioTemplateId }, include: ['urlLanguageString'] });
    }
    const newAudioTemplate = new Table.AudioTemplate();
    newAudioTemplate.set('urlLanguageString', new Table.LanguageString());
    return newAudioTemplate;
  }

  private loadAudioTemplateOptions(): Array<InputType.SelectOption> {
    return [
      { display: 'followUpSop', value: 'followUpSop' },
      { display: 'order', value: 'order' },
    ]
  }
}
